import { actionTypes} from '../actions/cryptoRates'
import createAsyncReducer from './HOCreducer'

export default createAsyncReducer(actionTypes)
